import { useState } from "react"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faXmark, faAngleLeft } from '@fortawesome/free-solid-svg-icons'
import { Toaster, toast } from 'react-hot-toast';
import SettingsCard from "./SettingsCard";
import Account from "./Account";
import Security from "./Security";
import Payment from "./Payment";
import Personal from "./Personal";
import Verification from "./Verification";
import { faCreditCard } from '@fortawesome/free-regular-svg-icons'
import { useUser } from "../utils/UserContext";

function Settings({settingsBar, toggleSettingsBar }) {
  const { user, setUser } = useUser();
  const logout = () => {
    fetch(`${process.env.REACT_APP_API_URL}controller/logout.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ logout: true})
    })
    .then(response => response.text())
    .then(data => {
      console.log(data);
      if (data === "success") {
        setUser(null); // clear user
        window.location.href = "login";
      }else{
        toast.error("Logout failed");
      }
    })
    .catch(err => {
      console.error(err)
    }) 
  };
  const [paymentBar, setPaymentBar] = useState(false);
  const [accountBar, setAccountBar] = useState(false);
  const [securityBar, setSecurityBar] = useState(false);
  const [personalBar, setPersonalBar] = useState(false);
  const [verificationBar, setVerificationBar] = useState(false);
  const togglePaymentBar = () => {
    setPaymentBar(!paymentBar);
  };
  const toggleAccountBar = () => {
    setAccountBar(!accountBar);
  };
  const toggleSecurityBar = () => {
    setSecurityBar(!securityBar);
  };
  const togglePersonalBar = () => {
    setPersonalBar(!personalBar);
  };
  const toggleVerificationBar = () => {
    setVerificationBar(!verificationBar);
  };
    return (
      <>
        <div><Toaster/></div>
        <div className={`notifybar ${settingsBar ? "active" : null}`}>
            <div className="d-flex align-items-center justify-content-between">
                <div className="d-flex align-items-center" style={{cursor: 'pointer'}}>
                    <FontAwesomeIcon icon={faAngleLeft} style={{color: 'white', cursor: 'pointer', fontSize: '14px'}} onClick={() => {toggleSettingsBar()}}/>
                    <p className="mb-0 fw-semibold ms-3 text-white">Settings</p>
                </div>
                <FontAwesomeIcon icon={faXmark} style={{color: 'gray', cursor: 'pointer', fontSize: '20px'}} onClick={() => {toggleSettingsBar()}}/>
            </div>
            <div className="sidebar-navbar" style={{height: 'auto'}}>
                <div className="d-flex align-items-center mb-3">
                    <div className="d-flex align-items-center justify-content-center me-2 rounded-2 overflow-hidden" style={{ width: "40px", height: "40px", backgroundColor: '#ffffff0d', borderRadius: '6px', color: '#f80',  }}>
                      {user.photo == "" ? (
                          <span className="fw-semibold">{user?.fullname?.substring(0, 2)}</span>
                      ) : (
                          <img src={`/uploads/${user.photo}`} alt="profile" className="w-100 h-100" style={{objectFit: 'cover'}}/>
                      )}  
                    </div>
                    <div>
                        <p className="fw-bold mb-0 lh-1">{user?.fullname}</p>
                        <p className="text-secondary fw-bold mb-0" style={{fontSize: '13px'}}>{user?.email}</p>
                    </div>
                </div> 
                <SettingsCard icon={<FontAwesomeIcon icon={faCreditCard} style={{fontSize: '15px'}}/>} name="Payments" text="Deposit and Withdraw" onClick={() => {togglePaymentBar()}}/>
                <p className="mt-3 mb-2 text-white fw-bold" style={{fontSize: '15px'}}>Profile</p>
                <SettingsCard icon={<FontAwesomeIcon icon={faCreditCard} style={{fontSize: '15px'}}/>} name="Verification" text="Verification and confirmation of identity" onClick={() => {toggleVerificationBar()}}/>
                <SettingsCard icon={<FontAwesomeIcon icon={faCreditCard} style={{fontSize: '15px'}}/>} name="Personal" text="Your personal information" onClick={() => {togglePersonalBar()}}/>
                <SettingsCard icon={<FontAwesomeIcon icon={faCreditCard} style={{fontSize: '15px'}}/>} name="Security" text="Email, password and 2FA" onClick={() => {toggleSecurityBar()}}/>
                <p className="mt-3 mb-2 text-white fw-bold" style={{fontSize: '15px'}}>Setup</p>
                <SettingsCard icon={<FontAwesomeIcon icon={faCreditCard} style={{fontSize: '15px'}}/>} name="Currency" text="Currency" onClick={() => {toggleAccountBar()}}/>
                <SettingsCard icon={<FontAwesomeIcon icon={faCreditCard} style={{fontSize: '15px'}}/>} addclass="mt-3" name="Logout" onClick={logout}/>
            </div>
        </div>
        <Payment togglePaymentBar={togglePaymentBar} paymentBar={paymentBar}/>
        <Account toggleAccountBar={toggleAccountBar} accountBar={accountBar}/>
        <Security toggleSecurityBar={toggleSecurityBar} securityBar={securityBar}/>
        <Personal togglePersonalBar={togglePersonalBar} personalBar={personalBar}/>
        <Verification toggleVerificationBar={toggleVerificationBar} verificationBar={verificationBar}/>
      </>
    )
}

export default Settings